export interface ProfileAction {
  id: number;
  action: string;
}

export interface Permission {
  id: number;
  formId: number;
  name: string;
  form: string;
  description: string;
  menu: string;
  url: string;
  listObjectUserProfileActionDTOs: ProfileAction[];
}

export const DASHBOARD = {
  ADMIN: "DashboardAdmin",
  MASTER: "DashboardMaster",
};

export const FORMS = {
  PROCEDURE_CUSTOMER: "ProcedureCustomer",
  PROCEDURE_TYPE: "ProcedureCustomerType",
};

export const FORMS_HEARING = {
  HEARING: "Hearing",
  HEARING_FILE: "HearingFile",
};

export const FORMS_ADMIN = {
  IMPORT_SISP: "ImportSISP",
  PROCE_CUSTO_SOURSE: "ProcedureCustomerSource",
  POLICE_UNIT: "PoliceUnit",
  ATTENDANT_ROLE: "AttendantRole",
  HEARING_TYPE: "HearingType",
  HEARING_SOURCE: "HearingSource",
  HEARING_FILE_TYPE: "HearingFileType",
  HEARING_FILE_TYPE_ATTENDANT_ROLE: "HearingFileTypeAttendantRole",
  ATTENDANT: "Attendant",
  PROFILE: "UserCustomerProfiles",
  USER_CUSTOMER: "UserCustomer",
  SYSTEM_CONFIGURATION: "SystemConfiguration",
  SYSTEM_WATERMARK: "SystemWatermark",
  CERTIFICATE: "CustomerCertificate",
  PROCEDURE_CUS_TYPE: "ProcedureCustomerType",
  HEARING_TYPE_ATTENDANT_ROLE: "HearingTypeAttendantRole",
  PROCEDURE_CUSTOMER_TYPE_ATTENDANT_ROLE: "ProcedureCustomerTypeAttendantRole",
  PROCEDURE_TYPE_ATTENDANT_ROLE: "ProcedureCustomerTypeAttendantRole",
  PLACE: "Place",
  SERVICE_INTEGRATION_IMPORTATION: "ServiceIntegrationImportation",
  CUSTOMER_TEMPLATE: "CustomerTemplate",
  ROLE_MAP_AD: "RoleMapAd",
};

export const FORMS_ADMIN_V2 = [
  { ProcedureCustomerSource: "ProcedureCustomerSource" },
  { PoliceUnit: "PoliceUnit" },
  { AttendantRole: "AttendantRole" },
  { HearingType: "HearingType" },
  { HearingSource: "HearingSource" },
  { HearingFileType: "HearingFileType" },
  { HearingFileTypeAttendantRole: "HearingFileTypeAttendantRole" },
  { Attendant: "Attendant" },
  { UserCustomerProfile: "UserCustomerProfile" },
  { UserCustomer: "UserCustomer" },
  { SystemConfiguration: "SystemConfiguration" },
  { SystemWatermark: "SystemWatermark" },
  { CustomerCertificate: "CustomerCertificate" },
  { ProcedureCustomerType: "ProcedureCustomerType" },
  { HearingTypeAttendantRole: "HearingTypeAttendantRole" },
  { ProcedureCustomerTypeAttendantRole: "ProcedureCustomerTypeAttendantRole" },
  { Place: "Place" },
];

export const ADMIN_ROUTES_BY_FORM_PERMISSION = [
  {
    route: "ImportSISP",
    formAdminPermissionName: "ImportSISP",
  },
  {
    route: "ProcedureCustomerSource",
    formAdminPermissionName: "ProcedureCustomerSource",
  },
  {
    route: "policeUnit",
    formAdminPermissionName: "PoliceUnit",
  },
  {
    route: "tiposParticipantes",
    formAdminPermissionName: "AttendantRole",
  },
  {
    route: "hearingType",
    formAdminPermissionName: "HearingType",
  },
  {
    route: "HearingSource",
    formAdminPermissionName: "HearingSource",
  },
  {
    route: "HearingFileType",
    formAdminPermissionName: "HearingFileType",
  },
  {
    route: "HearingFileTypeAttendantRole",
    formAdminPermissionName: "HearingFileTypeAttendantRole",
  },
  {
    route: "attendant",
    formAdminPermissionName: "Attendant",
  },
  {
    route: "users",
    formAdminPermissionName: "UserCustomer",
  },
  {
    route: "profiles",
    formAdminPermissionName: "UserCustomerProfile",
  },
  {
    route: "systemConfiguration",
    formAdminPermissionName: "SystemConfiguration",
  },
  {
    route: "customerCertificate",
    formAdminPermissionName: "CustomerCertificate",
  },
  {
    route: "procedureCustomerType",
    formAdminPermissionName: "ProcedureCustomerType",
  },
  {
    route: "procedureTypeAttendantRole",
    formAdminPermissionName: "ProcedureCustomerTypeAttendantRole",
  },
  {
    route: "Place",
    formAdminPermissionName: "Place",
  },
];

export const FORMS_RELATORIOS = {
  TRASCRIPTION: "TranscriptionsReport",
  LOG_ERROR: "LogError",
  LOG_OPERATION: "LogOperation",
  LOGGED_USERS: "LoggedUsers",
};

export const RELATORIO_ROUTES_BY_FORM_PERMISSION = [
  {
    route: "relatorio",
    formRelatorioPermissionName: "Report",
  },
  {
    route: "relatorio",
    formRelatorioPermissionName: "Logs",
  },
  {
    route: "error",
    formRelatorioPermissionName: "Procedimentos",
  },
];

export const FORM_EXPORT_FILES = {
  HEARING_FILE: "HearingFile",
};
